import React, { useEffect, useState } from "react";
import axios from "axios";
import { withNamespaces } from "react-i18next";
import AnalyticsIcon from "../../../resources/AnalyticsIcon.svg"
import lockIcon from "../../../resources/lockIcon.svg"
import BrokenLink from "../../../resources/BrokenLink.svg"
import Loader from "../../Global/Loader";
import { Services } from "../../../repositories/clients/Services";

import "./BiGerencial.scss";

const BiGerencial = ({ token, Email, t }) => {

  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState(null);
  const [noAccess, setNoAccess] = useState(false);
  const [ssoError, setSsoError] = useState(false);

  const NoAccessScreen = () => (
    <div className="bi-no-access">
      <div className="bi-no-access-icon">
        <img src={AnalyticsIcon} alt="chart" />
        <img src={lockIcon} alt="lock" className="lock-icon" />
      </div>

      <p>{t("analytics_not_permission_access")}</p>
    </div>
  );

  const SSOErrorScreen = () => (
    <div className="bi-no-access">
      <div className="bi-no-access-icon">
        <img src={AnalyticsIcon} alt="chart" />
        <img src={BrokenLink} alt="error" className="lock-icon" />
      </div>

      <p>{t("analytics_session_not_validated")}</p>

      <a href="" onClick={() => window.location.reload()}>
        {t("analytics_please_try_again")}
      </a>
    </div>
  );


  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const url = `${Services.ADMIN.path}oauth/tableau-url`
        const res = await axios.post(url, { Email });

        if (res.data.noAccess) {
          setNoAccess(true);
          setUrl(null);
        } else if (res.data.ssoError) {
          setSsoError(true)
          setUrl(null);
        } else {
          setUrl(res.data.url)
        }

      } catch (err) {
        setSsoError(true);
        setUrl(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();
  }, [Email]);

  if (loading) return <Loader />;

  if (noAccess) return <NoAccessScreen />

  if (ssoError) return <SSOErrorScreen />

  return (
    <div className="bi-gerencial-embed">
      <iframe src={url} title="BI Gerencial" frameBorder="0" />
    </div>
  );
};

export default withNamespaces()(BiGerencial);
